import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProductReportsLayer from "../components/ProductReportsLayer";

const ProductReportsPage = () => {
    return (
        <MasterLayout>
            <ProductReportsLayer />
        </MasterLayout>
    );
};

export default ProductReportsPage;
